import { useState } from 'react';

export function useCompanyImageState(): {
  isOpen: boolean;
  setIsOpen: (v: boolean) => void;
  isReset: boolean;
  setIsReset: (v: boolean) => void;
  imageBlob: Blob | null;
  setImageBlob: (v: Blob | null) => void;
  openCropper: () => void;
  resetCropper: () => void;
} {
  const [isOpen, setIsOpen] = useState(false);
  const [isReset, setIsReset] = useState(false);
  const [imageBlob, setImageBlob] = useState<Blob | null>(null);

  return {
    isOpen,
    setIsOpen,
    isReset,
    setIsReset,
    imageBlob,
    setImageBlob,
    openCropper: () => setIsOpen(true),
    resetCropper: () => setIsReset(true),
  };
}
